// Facebook (Meta) Pixel integration
// Pixel ID provided by the user.
export const FB_PIXEL_ID = '864893796672213'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel base code, initializes the pixel and
 * fires the initial PageView. Safe to call multiple times (no-ops after first).
 */
export function initFacebookPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (
      f: any,
      b: any,
      e: string,
      v: string,
      n?: any,
      t?: any,
      s?: any,
    ) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      t.onerror = function () {}
      s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', FB_PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (err) {
    // Never let pixel setup break the app (common in sandboxed previews).
    // eslint-disable-next-line no-console
    console.warn('Facebook Pixel init skipped:', err)
  }
}

/** Track a standard Meta Pixel event. */
export function trackPixelEvent(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', event, data)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Facebook Pixel track skipped:', err)
  }
}
